module.exports = __webpack_public_path__ + "static/img/Success.f57330e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Instruction/Success.png
// module id = 1747
// module chunks = 36 37